import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataTypePregunta } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

const cardLabel = (card: AllCardsType) => formatCardLabel(card)

export const interpret = (
    cards: AllCardsType[],
    data: DataTypePregunta,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    const consult = `Quiero que interpretes una **Tirada de Sanación del Niño Interior** con 10 cartas, ayudando al consultante ${
        data.consultante
    } a conectar con su niño interior, comprender sus heridas y abrir un camino de sanación y reparenting, ${
        data.consulta.length > 0
            ? 'ten en cuenta en la tirada la siguiente consulta que realiza el consultante: ' +
              data.consulta +
              ','
            : ''
    } según estas cartas: **Estado actual de tu niño interior (¿cómo está tu niño interior hoy?):** ${cardLabel(
        cards[0]
    )}, **La herida principal que carga (¿cuál es la herida más fuerte que sigue presente?):** ${cardLabel(
        cards[1]
    )}, **Cómo se manifiesta en tu vida adulta (¿de qué forma aparece esta herida hoy?):** ${cardLabel(
        cards[2]
    )}, **Qué necesitó y no recibió (¿qué necesitaba ese niño y no obtuvo?):** ${cardLabel(
        cards[3]
    )}, **Creencia que se formó (¿qué creencia limitante se generó a partir de esa herida?):** ${cardLabel(
        cards[4]
    )}, **Cómo te limita o sabotea hoy (¿de qué forma te está afectando actualmente?):** ${cardLabel(
        cards[5]
    )}, **Qué necesita tu niño interior ahora (¿qué necesita recibir de vos en este momento?):** ${cardLabel(
        cards[6]
    )}, **Cómo podés reparentarlo (¿qué acción concreta podés hacer para sanarlo?):** ${cardLabel(
        cards[7]
    )}, **El regalo que trae la sanación (¿qué fuerza o don te va a dar sanar esta herida?):** ${cardLabel(
        cards[8]
    )} y **Mensaje final de tu niño interior (¿qué quiere decirte tu niño interior ahora?):** ${cardLabel(
        cards[9]
    )}. Explica detalladamente cada carta y su significado en la posición donde ha salido. Teje una lectura coherente sobre la herida del niño interior: conecta el pasado con el presente, la creencia limitante, las necesidades no cubiertas y el camino de sanación. Detecta patrones de autosabotaje, bloqueos emocionales y oportunidades de reparenting. Proporciona consejos prácticos, tiernos y concretos para sanar y cuidar al niño interior. Mantén un tono profesional, empático, contenido y comprensible. Dirígete directamente al consultante, no utilices la tercera persona refiriéndote al consultante, aún cuando las consultas se encuentren en tercera persona, adapta la respuesta para que quede en segunda persona. Incluye además en 2 párrafos después de la lectura, una respuesta directa para el consultante y un consejo final (extra-tarot).`

    return {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }
}
